module.exports = __webpack_public_path__ + "4badfddaa6959c2d52b6b924045ee450.svg";